import defaultChecked from '@ecp/common/src/assets/theme/asiana/icon/checkbox--checked.svg';
import defaultDisabled from '@ecp/common/src/assets/theme/asiana/icon/checkbox--disabled.svg';
import defaultUnchecked from '@ecp/common/src/assets/theme/asiana/icon/checkbox--unchecked.svg';
import attendanceChecked from '@ecp/common/src/assets/icon/attendance--checked.svg';

export const favicon = '/ecp_favicon.ico';

export const color = {
  primary: '#444B51',
  secondary: '#727272',
  third: '#141415',
  disabled: '#d3d3d3',
  sub_darkgray: '#3C3C3C',
  sub: '#FF8718',
  fourth: '#23A0B1',
  stroke: '#F22214',
  hover: {
    primary: '#E65429',
    secondary: '#505050',
    third: '#444B51',
    default: '#eaeaea',
  },
  text: {
    basic: '#141415',
    basicTab: '#444B51',
    sub: '#5a5a5a',
    guide: '#727272',
    category: '#9c52ff',
    price: '#c551c0',
    white: '#ffffff',
    placeholder: '#a3a3a3',
    disabled: '#727272',
    error: '#f22214',
    event: '#7e9ae3',
    normal: '#7a7a7a',
    mileage: '#fbff94',
    attendance: '#444B51',
    attendanceEvent: '#ffffff',
    selected: '#444B51',
    food: '#fe6f1f',
    best: '#0dc335',
    policy: '#444B51',
    newPlaceholder: '#595959',
  },
  point: {
    basic: '#444B51',
    negative: '#f22214',
  },
  line: {
    basic: '#eaeaea',
    background: '#dfdfdf',
    emphasis: '#141415',
    category: '#9c52ff',
    price: '#c551c0',
    disabled: '#d3d3d3',
    error: '#f22214',
    selected: '#7a7a7a',
    sub: '#bdbdbd',
    line02: '#d3d3d3',
  },
  background: {
    basic: '#f7f7f7',
    sub: '#FFEFEA',
    sub1: '#FFEFEA',
    sub2: '#f3f3f3',
    white: '#ffffff',
    disabled: '#d3d3d3',
    gradient: '#FF8718',
    coupon: {
      good: '#efedff',
      cart: '#fff1ed',
      delivery: '#e2f8ff',
      default: '#5a5a5a',
    },
    arrow: {
      md: '#FFF2EE',
    },
    navigation: '#f7f7f7',
    error: '#ffa2a2',
  },
  icon: {
    default: '#919191',
    current: '#444B51',
    normal: '#6a6a6a',
    badge: '#27b7db',
    benefit: '#e0dcff',
  },
};

export const font = {
  family: "'Noto Sans KR', Arial, Helvetica, sans-serif",
  size: {
    tiny: '10px',
    calendar: '11px',
    error: '12px',
    small: '13px',
    basic: '14px',
    table: '15px',
    label: '16px',
    menu: '17px',
    title: '18px',
    popup: '20px',
    medium: '21px',
    percent: '22px',
    banner: '24px',
    discount: '26px',
    large: '28px',
    hero: '48px',
  },
  weight: {
    demiLight: 300,
    medium: 500,
    medium2: 400,
    bold: 600,
  },
  lineHeight: {
    error: '19px',
    demiLight: '160%',
    medium: '140%',
    bold: '100%',
  },
  'line-spacing': {},
  height: {
    error: '19px',
  },
};

export const image = {
  defaultChecked: defaultChecked,
  defaultDisabled: defaultDisabled,
  defaultUnchecked: defaultUnchecked,
  attendanceChecked: attendanceChecked,
};

export const mobile = {
  numberIndicator: {
    suffixColor: color.text.placeholder,
  },
  footer: {
    contactInfo: {
      borderRadius: '',
    },
  },
  myCouponSeeMoreButton: {
    border: `1px solid ${color.line.sub}`,
  },
};

export const component = {
  input: {
    // input border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border: 1px solid ${color.line.disabled};`,
    disabledBorder: `border: 1px solid ${color.line.disabled};`,
    selectedBorder: `border: 1px solid ${color.line.selected};`,
    errorBorder: `border: 1px solid ${color.line.error};`,
  },
  button: {
    borderRadius: '4px',
    border: color.text.guide,
    primary: {
      backgroundColor: '#444B51',
      pressed: {
        color: '',
      },
      hover: {
        backgroundColor: '#444B51',
      },
      color: '#ffffff',
    },
    secondary: {
      color: '#ffffff',
      border: '',
      backgroundColor: '#727272',
      hover: {
        backgroundColor: '#505050',
      },
      pressed: {
        backgroundColor: '#727272',
      },
    },
    third: {
      backgroundColor: '#141415',
      pressed: {
        color: '',
      },
      hover: {
        backgroundColor: '#444B51',
      },
      color: '',
    },
    default: {
      border: '1px solid #727272',
    },
  },
  dropdown: {
    // dropdown border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border: 1px solid ${color.line.disabled};`,
    fontSize: '13px',
  },
  numberIndicator: {
    border: '1px',
    borderRadius: '4px',
    background: `${color.background.white}`,
    width: '40px',
    padding: '0 4px',
    button: {
      border: `none`,
      borderRadius: '',
      background: '',
    },
  },
  imageFileUploader: {
    borderRadius: '',
  },
  swiperMainItem: {
    bannerText1: {
      top: '170px',
    },
    bannerText2: {
      top: '228px',
    },
    bannerText3: {
      top: '336px',
    },
  },
  gnb: {
    logo: {
      marginRight: '147px',
    },
    cart: {
      top: -8,
      right: -8,
    },
  },
  good: {
    selectedOption: {
      borderRadius: '',
    },
  },
  order: {
    orderContentHeader: {
      borderBottom: 'none',
      paddingBottom: '0',
    },
    orderContainer: {
      borderRadius: '',
    },
    headerContainer: {
      borderTop: '2px solid',
      borderRadius: '',
    },
    orderGoodItemInformation: {
      orderContainer: {
        borderTop: 'none',
      },
    },
    orderGoodContent: {
      orderGoodList: {
        borderRadius: 'none',
      },
    },
    payment: {
      agreeTermsConditions: {
        root: {
          borderRadius: '0',
        },
      },
      orderPaymentTermsAccordion: {
        accordion: {
          borderRadius: '0',
        },
        flexBox: {
          borderRadius: '0',
        },
      },
    },
    cart: {
      optionButton: {
        border: `1px solid ${color.line.disabled}`,
        borderRadius: '4px',
      },
    },
  },
  myPage: {
    myPageOrderPage: {
      periodSearch: {
        borderRadius: '10px',
      },
    },
    myPageOrderList: {
      orderMasterContainer: {
        // 없을 수도 있기때문에 통으로 삽입
        borderTop: `border-top: 2px solid ${color.line.emphasis};`,
        borderRadius: '',
      },
    },
    myPageOrderListItemHead: {
      container: {
        borderRadius: '',
      },
    },
    deliveryLocation: {
      cellButton: {
        borderRadius: '4px',
      },
    },
  },
  customerService: {
    informationEntryGrid: {
      labelBox: {
        backgroundColor: color.background.basic,
      },
    },
  },
  termViewForm: {
    textBox: {
      borderRadius: '',
    },
  },
  mobile,
};

export const theme = {
  id: 'default',
  favicon,
  color,
  font,
  image,
  component,
};

export default theme;
